export default __webpack_public_path__ + "static/media/marketing_img_2.d9240b33.jpg";